module.exports = __webpack_public_path__ + "img/i20.6dcf592d.png";